import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layer deletAlt" }
const _hoisted_2 = { class: "layerMain" }
const _hoisted_3 = {
  class: "confirminputArea",
  style: {"margin-bottom":"20px","margin-left":"40px","overflow":"auto"}
}
const _hoisted_4 = { class: "layerBtnArea" }
const _hoisted_5 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "layerTitle" }, "보안 인증 문자 메시지", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "layerMainText",
          style: {"font-size":"20px"}
        }, [
          _createElementVNode("span", { class: "bold" }, "회원 가입시 등록하신 휴대폰"),
          _createTextVNode("으로 "),
          _createElementVNode("br"),
          _createTextVNode("인증 메시지를 발송하였습니다. ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            ref: "smsInput",
            type: "text",
            class: "confirminput",
            name: "smsnum",
            style: {"width":"200px","height":"50px","padding":"0 5px 4px 10px","border":"1px solid #c9c9c9","color":"#777777","font-size":"18px","font-family":"'맑은고딕'","float":"left","border-radius":"10px 0 0 10px"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.certTxt) = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($options.approve && $options.approve(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.certTxt]
          ]),
          _createElementVNode("button", {
            class: "confirminputBtn",
            style: {"width":"80px","height":"56px","border":"1px solid #c9c9c9","color":"#575757","font-size":"18px","cursor":"pointer","margin-left":"-1px","float":"left","border-radius":"0 10px 10px 0"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.approve && $options.approve(...args)))
          }, " 확인 "),
          _createElementVNode("p", {
            class: _normalizeClass(["bold", [$data.certTime > 0 ? 'blue' : 'red']]),
            style: {"clear":"left"}
          }, "입력가능시간" + _toDisplayString($options.certTimeStr), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.resend && $options.resend(...args)))
        }, "문자 메시지 다시 보내기")
      ])
    ], 512), [
      [_vShow, $data.visible]
    ]),
    ($data.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "spinner" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}